import { render, staticRenderFns } from "./BrightbackCancel.vue?vue&type=template&id=1928df95&"
import script from "./BrightbackCancel.vue?vue&type=script&lang=js&"
export * from "./BrightbackCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports